import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    constructor(props) {
        super(props);
        this.rangeLimits = props.rangeLimits;
    }

    handleSliderChange(values) {
        const {positionsGroup} = this.props;

        this.props.dispatch(Action.set('RangeOfOutcomesByPositions', positionsGroup, parseInt(values[0])));
    }

    render() {
        const {rangeOfOutcomesByPositions, step = 1, positionsGroup} = this.props;
        const value = rangeOfOutcomesByPositions.getRangeOfOutcomesPctByPositions(positionsGroup);
        const minVal = this.rangeLimits.getMin();
        const maxVal = this.rangeLimits.getMax();

        return (
            <SliderAdapter
                key={`slider-${value}`}
                onChange={::this.handleSliderChange}
                min={minVal}
                max={maxVal}
                defaultValue={value}
                thumb={<div className="circle"></div>}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {rangeOfOutcomesByPositions} = state;

    return {
        rangeOfOutcomesByPositions,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
